import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { homeLocales } from "./components/home/locales";
import { landingLocales } from "./components/landing/locales";
import { downloadLocales } from "./components/download/locales";
import { aboutLocales } from "./components/about/locales";
import { dataLocales } from "./components/data/locales";
import { componentLocales } from "./components/locales";
import { testimonialsLocales } from "./testimonialsData/locales";

// Safely get stored language
const getStoredLanguage = (): string | null => {
  try {
    return localStorage.getItem("i18nextLng");
  } catch {
    return null;
  }
};

const initializeI18n = async () => {
  const initialLang = getStoredLanguage() || "fa";

  await i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
          resources: {
              fa: {
                ...homeLocales.fa,
                ...landingLocales.fa,
                ...downloadLocales.fa,
                ...aboutLocales.fa,
                ...dataLocales.fa,
                ...componentLocales.fa,
                ...testimonialsLocales.fa,
            },
            en: {
                ...homeLocales.en,
                ...landingLocales.en,
                ...downloadLocales.en,
                ...aboutLocales.en,
                ...dataLocales.en,
                ...componentLocales.en,
                ...testimonialsLocales.en,
            },
            ar: {
                ...homeLocales.ar,
                ...landingLocales.ar,
                ...downloadLocales.ar,
                ...aboutLocales.ar,
                ...dataLocales.ar,
                ...componentLocales.ar,
                ...testimonialsLocales.ar,
            },
            tr: {
                ...homeLocales.tr,
                ...landingLocales.tr,
                ...downloadLocales.tr,
                ...aboutLocales.tr,
                ...dataLocales.tr,
                ...componentLocales.tr,
                ...testimonialsLocales.tr,
            },
          },
          lng: initialLang,
          fallbackLng: "fa",
          supportedLngs: ["en", "fa", "ar", "tr"],
          detection: {
              order: ["localStorage", "cookie", "navigator"],
              caches: ["localStorage", "cookie"],
              lookupLocalStorage: "i18nextLng",
          },
          interpolation: {
              escapeValue: false,
          },
          react: {
              useSuspense: false,
          },
      });

  return i18n;
};

export default i18n;
export { initializeI18n };
